import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IoIosLogOut, IoMdMenu } from 'react-icons/io';
import '../../styles/internal/Sidebar.css';

export default function Sidebar() {
  const [menuAberto, setMenuAberto] = useState(false);
  const navigate = useNavigate();

  const abrirMenu = () => setMenuAberto(true);
  const fecharMenu = () => setMenuAberto(false);

  const logout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <>
      <div className="sidebar">
        <h2 className="sidebar-title">Guardian - NFs</h2>
        <nav className="sidebar-nav">
          <Link to="#" className="sidebar-link">Home</Link>
          <Link to="/dashboard" className="sidebar-link">Notas Fiscais</Link>
          <Link to="/" className="sidebar-link logout-link" onClick={logout}>
            <span className="logout-content">
              <span>Sair</span>
              <IoIosLogOut />
            </span>
          </Link>
        </nav>
      </div>

      <div className="mobile-toggle">
        <span style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Guardian - NFs</span>
        <IoMdMenu className="hamburger" onClick={abrirMenu} />
      </div>

      <div className={`mobile-menu ${menuAberto ? 'open' : ''}`}>
        <nav className="sidebar-nav">
          <Link to="#" className="sidebar-link" onClick={fecharMenu}>Home</Link>
          <Link to="/dashboard" className="sidebar-link" onClick={fecharMenu}>Notas Fiscais</Link>
          <Link to="#" className="sidebar-link logout-link" onClick={() => { fecharMenu(); logout(); }}>
            <span className="logout-content">
              <span>Sair</span>
              <IoIosLogOut />
            </span>
          </Link>
        </nav>
      </div>

      {menuAberto && <div className="overlay" onClick={fecharMenu}></div>}
    </>
  );
}
